(function (angular) {
    'use strict';

    angular.module('broadcast')

        /**
         *
         */
        .factory('audienceCreatorService',
            ["$uibModal",
                function ($uibModal) {

                    var fac = {
                        createAudience: function (isTest) {

                            var modalInstance = $uibModal.open({
                                animation: true,
                                templateUrl: 'components/toolkit/profiles/templates/profileSearchModal.html',
                                controller: 'profileSearchModal',
                                size: "lg",
                                resolve: {
                                    buttonInfo: [function () {
                                        return {
                                            createAudience: true,
                                            isTest: isTest
                                        };
                                    }],
                                    profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                                        if (profileHelper.getSchema().length) {
                                            return profileHelper.getSchema();
                                        }
                                        else {
                                            return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                                .then(function (result) {
                                                    return profileHelper.setSchema(result);
                                                }).catch(function (result) {
                                                    var deferred = $q.defer();
                                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                                    return deferred.promise;
                                                });
                                        }
                                    }],
                                }
                            });

                            return modalInstance;

                        }
                    };

                    return fac;

                }]);

})(window.angular);